module.exports = __webpack_public_path__ + "img/EgyptAcademy.0b24c887.jpg";